<template>
  <div class="performance">
    <div class="list">
      <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
        :loading-text="$t('Hint.loading')">
        <template v-if="list.length">
          <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
            {{ item }}
          </div>
        </template>
        <div class="list_not" v-else>
          <img :src="require('@/assets/Img/null/null.png')" alt="">
        </div>
      </List>
    </div>
  </div>
</template>
<script>
import { Toast, List } from 'vant';
import { } from "@/api"
import { post } from "@/utils/newRequest";
export default {
  components: {
    Toast,
    List
  },
  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
    }
  },
  methods: {
    async getList() {
      return;
      this.page++;
      try {
        const { lists, hasMorePages } = await post("", {
          pagesize: 20,
          page: this.page,
        });
        console.log(lists);
        const realList = lists;
        this.hasMore = hasMorePages;
        this.list = [...this.list, ...realList];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.page--;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.performance {
  .list {
    margin-top: 12px;
    .list_not {
      padding: 32px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  
      img {
        width: 160px;
        height: 160px;
        display: block;
      }
  
      span {
        color: #7a8597;
        font-size: 14px;
        padding: 16px 0 14px;
      }
    }
  }

}
</style>